import { css } from 'styled-components';

export default css`
  .slider {
    position: relative;
    width: inherit;
  }

  .slider__track,
  .slider__range {
    border-radius: 3px;
    height: 5px;
    position: absolute;
  }

  .slider__track {
    width: 100%;
    z-index: 1;
  }

  .slider__range {
    background-color: #000;
    z-index: 2;
  }

  /* Removing the default appearance */
  .thumb {
    pointer-events: none;
    position: absolute;
    height: 0;
    width: inherit;
    outline: none;
    left: -2px;
  }

  .thumb,
  .thumb::-webkit-slider-thumb {
    -webkit-appearance: none;
    -webkit-tap-highlight-color: transparent;
  }

  .thumb--zindex-3 {
    z-index: 3;
    width: 100%;
  }

  .thumb--zindex-4 {
    z-index: 4;
    width: 100%;
  }

  /* For Chrome browsers */
  .thumb::-webkit-slider-thumb {
    background-color: #ffffff;
    border: 3px solid #000000;
    border-radius: 50%;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.08);
    cursor: pointer;
    height: 28px;
    width: 28px;
    margin-top: 4px;
    pointer-events: all;
    position: relative;
  }

  /* For Firefox browsers */
  .thumb::-moz-range-thumb {
    background-color: #ffffff;
    border: 3px solid #000000;
    border-radius: 50%;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.08);
    cursor: pointer;
    height: 28px;
    width: 28px;
    margin-top: 4px;
    pointer-events: all;
    position: relative;
  }

  .thumb--zindex-5 {
    z-index: 5;
  }

  .slider__left-value,
  .slider__right-value {
    font-family: 'Nunito';
    font-style: normal;
    color: #535353;
    font-size: 13px;
    margin-top: 20px;
    line-height: 18px;
    font-weight: 600;
    position: absolute;
  }

  .slider__left-value {
    left: 6px;
  }

  .slider__right-value {
    right: -4px;
  }
  .range {
    position: relative;
    width: inherit;
  }
  .min-val-tooltip,
  .max-val-tooltip {
    font-family: 'Nunito';
    font-style: normal;
    font-weight: 700;
    font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy2}px;
    line-height: 19px;
    width: 41px;
    background: rgb(26, 26, 26);
    color: rgb(255, 255, 255);
    text-align: center;
    border-radius: 5px;
    padding: 2px;
    position: absolute;
    z-index: 1;
    bottom: 17px;
    left: -10px;
  }
  .new-width {
    width: 48px;
  }

  .min-val-tooltip::after,
  .max-val-tooltip::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #000 transparent transparent transparent;
  }

  .pd-top {
    padding-top: 32px;
    padding-bottom: 40px;
  }

  .quick-filters-design {
    padding-bottom: 0;
    padding-top: 12px;
  }

  .hide {
    display: none;
  }

  .price-redesign-wrapper {
    display: flex;
    font-weight: 800;
    font-size: 14px;
    margin-top: 20px;
    font-family: ${({ theme }) => theme.typography.fonts.secondary};
    margin-left: 24px;
    line-height: 150%;
    letter-spacing: 1px;
    gap: 2px;
  }
  .thumb-redesign {
    pointer-events: none;
    position: absolute;
    height: 0;
    width: 100%;
    outline: none;
    left: -2px;
  }
  /* For Chrome browsers */
  .thumb-redesign::-webkit-slider-thumb {
    background-color: #ffffff;
    border: 6px solid #000000;
    border-radius: 50%;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.08);
    cursor: pointer;
    height: 24px;
    width: 24px;
    margin-top: 4px;
    pointer-events: all;
    position: relative;
  }

  /* For Firefox browsers */
  .thumb-redesign::-moz-range-thumb {
    background-color: #ffffff;
    border: 6px solid #000000;
    border-radius: 50%;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.08);
    cursor: pointer;
    height: 24px;
    width: 24px;
    margin-top: 4px;
    pointer-events: all;
    position: relative;
  }
`;
